<template>
	<j-box class="flex wrap xs-12 margin-center xs-center xs-top pr4 pl4 mt10">
		<!-- Form -->
		<template v-if="isUrlParamsValid && !isDone">
			<j-card class="flex wrap xs-12 xs-center p8 bg5 pt8 pb8 max5">
				<j-headline class="fs7 lh125 fw7 c1 mb1">{{
					$t("login.new_password")
				}}</j-headline>
				<form class="flex wrap xs-12" @submit.prevent="onSubmit">
					<j-box class="lh150 c6 ta2">
						{{ $t("login.please_set_new_password") }}
					</j-box>

					<j-box class="xs-12">
						<crm-password-rules :passwordRules="passwordRules" />
					</j-box>

					<!--  Password 1 -->
					<j-box class="xs-12 mb4 mt2">
						<j-base-label for="password1" class="lh150">{{
							$t("login.new_password")
						}}</j-base-label>
						<j-base-input-password
							id="password1"
							name="password1"
							v-model="password1"
							ref="password1"
							autocomplete="password"
							:status="errors.first('password1') ? 'error' : null"
							data-vv-validate-on="blur"
							:data-vv-as="$t('password')"
							v-validate="{ required: true }"
						/>
						<j-text class="fs3 lh125 mt1 cError">{{
							errors.first("password1")
						}}</j-text>
					</j-box>

					<!-- Password 2 -->
					<j-box class="xs-12 mb4">
						<j-base-label for="password2" class="lh150">{{
							$t("login.confirm_password")
						}}</j-base-label>
						<j-base-input-password
							id="password2"
							name="password2"
							ref="password2"
							v-model="password2"
							data-vv-validate-on="blur"
							:data-vv-as="$t('password')"
							:status="errors.first('password2') ? 'error' : null"
							v-validate="{ required: true, confirmed: 'password1' }"
						/>
						<j-text class="fs3 lh125 mt1 cError">{{
							errors.first("password2")
						}}</j-text>
					</j-box>

					<!-- Button -->
					<j-box class="flex xs-12 xs-center">
						<j-button :isLoading="isLoading" size="large">
							{{ $t("login.save") }}
						</j-button>
					</j-box>
				</form>
			</j-card>
		</template>

		<!-- Error, missing loginId or code -->
		<template v-if="!isUrlParamsValid && !isDone">
			<j-card class="flex wrap xs-12 xs-center p8 bg5 max4">
				<j-headline class="fs5 lh125 fw7 cError">{{
					$t("errors.invalid_url")
				}}</j-headline>
			</j-card>
		</template>

		<!-- Thank you page -->
		<template v-if="isDone">
			<j-card class="flex wrap xs-12 xs-center p8 bg5 max5">
				<j-headline class="fs6 lh125 fw7 cSuccess mb2">{{
					$t("login.success")
				}}</j-headline>
				<j-box class="fs4 lh150 c6 ta2">{{
					$t("login.password_has_been_set")
				}}</j-box>
			</j-card>
		</template>

		<!-- Back to login -->
		<j-box class="xs-12 ta2 mt6 mb10">
			<router-link :to="`/${$route.params.tenantId}/login`" class="c6">
				&larr; {{ $t("login.back_to_login") }}
			</router-link>
		</j-box>
	</j-box>
</template>

<script>
import JBox from "@/components/JBox/"
import JCard from "@/components/JCard/"
import JHeadline from "@/components/JHeadline/"
import JBaseInputPassword from "@/components/JBaseInputPassword/"
import JBaseLabel from "@/components/JBaseLabel/"
import JButton from "@/components/JButton/"
import JText from "@/components/JText/"
import CrmPasswordRules from "@/components/CrmPasswordRules/"

export default {
	name: "page-login-signin",
	components: {
		JBox,
		JCard,
		JHeadline,
		JBaseInputPassword,
		JButton,
		JBaseLabel,
		JText,
		CrmPasswordRules
	},

	data() {
		return {
			isLoading: false,
			isDone: false,
			password1: null,
			password2: null,
			passwordRules: null
		}
	},

	computed: {
		isUrlParamsValid() {
			if (
				this.$route.query.loginId &&
				this.$route.query.code &&
				this.$route.params.tenantId
			)
				return true
			return false
		}
	},

	methods: {
		async onSubmit() {
			this.isLoading = true

			this.$validator.validate().then(isValid => {
				if (isValid) {
					this.$store
						.dispatch("auth/newPassword", {
							tenantId: this.$route.params.tenantId,
							loginId: this.$route.query.loginId,
							code: this.$route.query.code,
							password: this.password1
						})
						.then(res => {
							if (res) this.isDone = true
							this.isLoading = false
						})
				} else this.isLoading = false
			})
		}
	},
	async mounted() {
		this.passwordRules = await this.$store.dispatch(
			"auth/getPasswordValidators",
			this.$store.state.tenantId
		)
	}
}
</script>
